import {
  BarChart3,
  Repeat as Bridge,
  Search,
  CoinsIcon,
  Rocket,
  Code2,
  Wallet,
  ArrowRightLeft,
  Blocks,
  Lightbulb
} from 'lucide-react';

const features = [
  {
    icon: BarChart3,
    title: 'Quantum DEX',
    description: 'Lightning-fast decentralized exchange',
    stats: ['5,000 TPS', '0.1% Fees', 'Cross-chain Ready']
  },
  {
    icon: Bridge,
    title: 'Quantum Bridge',
    description: 'Seamless cross-chain transfers',
    stats: ['Instant', 'Multi-network', 'Quantum-Safe']
  },
  {
    icon: Search,
    title: 'Block Explorer',
    description: 'Advanced transaction tracking',
    stats: ['Real-time', 'Analytics', 'API']
  },
  {
    icon: CoinsIcon,
    title: 'Quantum Staking',
    description: 'Enhanced staking protocol',
    stats: ['15% APY', 'Auto Compounding', 'Flexible Lock Options']
  },
  {
    icon: Rocket,
    title: 'LaunchPad',
    description: 'Secure project launches',
    stats: ['Multi-Sig Verified', 'Fair Launch Model', 'Instant Liquidity Setup']
  },
  {
    icon: Code2,
    title: 'Developer Grants',
    description: 'Supporting innovation',
    stats: ['$100K Pool', 'Support', 'Tools']
  }
];

const additionalFeatures = [
  {
    icon: Wallet,
    title: 'Quantum Wallet',
    description: 'Secure storage'
  },
  {
    icon: ArrowRightLeft,
    title: 'Cross-chain Swaps',
    description: 'Instant transfers'
  },
  {
    icon: Blocks,
    title: 'Smart Contracts',
    description: 'Quantum-safe'
  },
  {
    icon: Lightbulb,
    title: 'Innovation Hub',
    description: 'Research platform'
  }
];

export default function QuantumCore() {
  return (
    <div className="py-0 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="font-tokyo text-3xl font-bold bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent mb-2">
            Quantum Core Ecosystem
          </h2>
          <p className="text-sm text-quantum-light/80 max-w-2xl mx-auto">
            Experience the power of our sovereign Layer 1 infrastructure — quantum-ready, ultra-fast, and built for the future of decentralization.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          {features.map((feature) => (
            <div key={feature.title} className="quantum-card p-4 hover:scale-[1.02] transition-transform duration-300">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-quantum-primary to-quantum-secondary flex items-center justify-center">
                  {feature.icon && <feature.icon className="w-5 h-5 text-white" />}
                </div>
                <h3 className="text-lg font-semibold text-quantum-light ml-3">{feature.title}</h3>
              </div>
              <p className="text-sm text-quantum-light/70 mb-3">{feature.description}</p>
              <div className="grid grid-cols-3 gap-2">
                {feature.stats.map((stat, index) => (
                  <div key={index} className="quantum-card p-2 text-center">
                    <span className="text-xs text-quantum-light/90">{stat}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="quantum-card p-6 bg-gradient-to-r from-quantum-primary/10 to-quantum-secondary/10">
          <h3 className="text-xl font-bold text-quantum-light mb-4 text-center">
            Additional Features
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {additionalFeatures.map((feature) => (
              <div key={feature.title} className="text-center quantum-card p-4 hover:bg-white/5 transition-all duration-300">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center mx-auto mb-3">
                  {feature.icon && <feature.icon className="w-5 h-5 text-quantum-primary" />}
                </div>
                <h4 className="text-sm font-medium text-quantum-light mb-2">{feature.title}</h4>
                <p className="text-xs text-quantum-light/70">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}